import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Chart from "chart.js";
import chroma from "chroma-js";
import styled from "styled-components";

import {
  colors,
  useTabletLandscape,
  useMaxTabletPortrait,
} from "../../../../theme";
import { SERIES_NBR } from "./CovidHerdImmunityConstants";

const Container = styled.section`
  width: 592px;

  @media (max-width: 1599px) {
    width: 464px;
  }

  @media (max-width: 1023px) {
    width: 424px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

function CovidHerdImmunityChart({ restart, lastSeries, showYLegend }) {
  const canvas = useRef();
  const covidChart = useRef();
  const isTabledLandscape = useTabletLandscape();
  const isMaxTabletPortrait = useMaxTabletPortrait();

  // let aspectRatio = 3.6;
  let aspectRatio = 4.75;
  if (isTabledLandscape) {
    // aspectRatio = 2.8;
    aspectRatio = 3.75;
  } else if (isMaxTabletPortrait) {
    // aspectRatio = 2.6;
    aspectRatio = 3.4;
  }

  useEffect(() => {
    const ctx = canvas.current.getContext("2d");
    covidChart.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: new Array(SERIES_NBR),
        datasets: [
          {
            backgroundColor: colors.red,
            borderColor: chroma(colors.red).darken(1).css(),
            data: [],
          },
          {
            backgroundColor: colors.green,
            borderColor: chroma(colors.green).darken(1).css(),
            data: [],
          },
          {
            backgroundColor: colors.yellow,
            borderColor: chroma(colors.yellow).darken(1).css(),
            data: [],
          },
          {
            backgroundColor: colors.purple,
            borderColor: chroma(colors.purple).darken(1).css(),
            data: [],
          },
        ],
      },
      options: {
        aspectRatio,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        elements: {
          line: {
            borderWidth: 2,
            tension: 0,
          },
          point: {
            radius: 0,
          },
        },
        animation: {
          duration: 0,
        },
        responsiveAnimationDuration: 0,
        scales: {
          xAxes: [
            {
              display: false,
              ticks: {
                suggestedMax: SERIES_NBR,
                sampleSize: SERIES_NBR,
              },
            },
          ],
          yAxes: [{ display: showYLegend, stacked: true }],
        },
      },
    });
  }, [showYLegend, aspectRatio]);

  useEffect(() => {
    if (covidChart.current && lastSeries) {
      const data = covidChart.current.data;
      data.datasets[0].data.push(lastSeries[1]);
      data.datasets[1].data.push(lastSeries[0]);
      data.datasets[2].data.push(lastSeries[2]);
      data.datasets[3].data.push(lastSeries[3]);
      covidChart.current.update(0);
    }
  }, [lastSeries]);

  useEffect(() => {
    const data = covidChart.current.data;
    data.datasets[0].data = [];
    data.datasets[1].data = [];
    data.datasets[2].data = [];
    data.datasets[3].data = [];
    covidChart.current.update(0);
  }, [restart]);

  return (
    <Container>
      <h2>Évolution au fil du temps</h2>
      <canvas ref={canvas} aria-label="Graphique de propagation du COVID-19" />
    </Container>
  );
}

CovidHerdImmunityChart.propTypes = {
  lastSeries: PropTypes.shape({
    "0": PropTypes.number.isRequired,
    "1": PropTypes.number.isRequired,
    "2": PropTypes.number.isRequired,
    "3": PropTypes.number.isRequired,
  }),
  restart: PropTypes.number.isRequired,
  showYLegend: PropTypes.bool.isRequired,
};

CovidHerdImmunityChart.defaultProps = {
  restart: 0,
  showYLegend: true,
};

export default CovidHerdImmunityChart;
